// assets
import { UsergroupAddOutlined, TeamOutlined, PlusOutlined, EditOutlined, InfoCircleOutlined } from '@ant-design/icons';
import GroupsIcon from '@mui/icons-material/Groups';

// icons
const icons = {
  UsergroupAddOutlined,
  TeamOutlined,
  PlusOutlined,
  EditOutlined,
  InfoCircleOutlined,
  GroupsIcon
};

// ==============================|| MENU ITEMS - GROUP ROUTES ||============================== //

const GroupRoute = {
  id: 'group-management',
  title: 'Groups',
  type: 'group',
  children: [
    {
      id: 'group-list',
      title: 'Group List',
      type: 'item',
      url: '/groups/list',
      icon: icons.GroupsIcon,
      target: false
    }
  ]
};

export default GroupRoute;
